import { Tag } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { DraggableActionsButton } from '../../../inputs/common/option-list/style/DraggableActionsButton';
import { WidgetOptionStructure } from '../../../inputs/common/option-list/style/WidgetOptionStructure';
import { ITableRow } from '../ITableRow';

const PreCol = styled.div`
  width: 10%;
  padding: 0 4px;
`;
const ValueCol = styled.div`
  width: 45%;
  font-family: monospace;
  font-weight: 600;
  padding: 0 4px;
  font-size: 0.9em;
  word-wrap: break-word;
`;
const OptionCol = styled.div`
  width: 45%;
  padding: 0 4px;
`;

export interface ITableRowViewProps {
  item: ITableRow;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function TableRowView(props: ITableRowViewProps) {
  const { item, listeners, ...actions } = props;
  return (
    <WidgetOptionStructure
      listeners={listeners}
      actions={<DraggableActionsButton {...actions} />}
    >
      <PreCol>
        {item.customRow ? <Tag color="blue-inverse">Cs</Tag> : <Tag>St</Tag>}
      </PreCol>
      <ValueCol>{item.code}</ValueCol>
      <OptionCol>
        <RichTextAdvancedRender inline text={item.label} />
      </OptionCol>
    </WidgetOptionStructure>
  );
}
